import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

export function StorageImage({ path, className, alt, onClick }) {
  const [objectUrl, setObjectUrl] = useState(null);
  useEffect(() => {
    if (!path) return;
    if (path.startsWith('http')) { setObjectUrl(path); return; }
    let cancelled = false;
    let url = null;
    supabase.storage.from('pm-inspection-images').download(path).then(({ data }) => {
      if (data && !cancelled) { url = URL.createObjectURL(data); setObjectUrl(url); }
    });
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (!objectUrl) return null;
  return <img src={objectUrl} className={className} alt={alt} onClick={onClick} />;
}
